// polyfill all `core-js` features:
// import "core-js";
// polyfill compilled generator & async functions
// import "regenerator-runtime/runtime";
import React from "react";
import configureStore from "./store/configureStore.js";
import { render } from "react-dom";
import { Provider } from "react-redux";
import App from "./app";
// import { requestLoadUser } from "actions/authentication";
import { registerServiceWorker } from "./../register-sw";
import "./index.scss";
import { NEW_RELIC_APP_ID, NEW_RELIC_LICENSE_KEY } from "environment";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

if (NEW_RELIC_APP_ID && NEW_RELIC_LICENSE_KEY) {
  new BrowserAgent({
    info: {
      applicationID: NEW_RELIC_APP_ID,
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: NEW_RELIC_LICENSE_KEY,
      sa: 1
    },
    init: {
      ajax: { deny_list: ["bam.nr-data.net"] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      spa: { enabled: true },
      performance: { capture_detail: false, capture_marks: false, capture_measures: true },
      privacy: { cookies_enabled: true }
    },
    loader_config: {
      accountID: "7784721",
      agentID: NEW_RELIC_APP_ID,
      applicationID: NEW_RELIC_APP_ID,
      licenseKey: NEW_RELIC_LICENSE_KEY,
      trustKey: "672447"
    }
  });
}

const store = configureStore();
// store.dispatch(requestLoadUser());
registerServiceWorker();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("app")
);

if (module.hot) {
  module.hot.accept();
}
